<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>{{ $t('common.client') }}</th>
            <th>{{ $t('components.subscription.purchase_date') }}</th>
            <th>{{ $t('components.subscription.start_date') }}</th>
            <th>{{ $t('components.subscription.expiring_date') }}</th>
            <th>{{ $t('components.subscription.residual_appointments') }}</th>
        </tr>
        </thead>
        <tbody>
        <SubscriptionActiveRow
            :subscription="subscription"
            v-for="subscription in subscriptions"
            v-bind:key="subscription.id"
        ></SubscriptionActiveRow>
        </tbody>
    </table>
</template>

<script>
import SubscriptionActiveRow from "@/components/subscription/SubscriptionActiveRow";

export default {
    name: "SubscriptionsActiveTable",
    components: {SubscriptionActiveRow},
    props: {
        subscriptions: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>